<template>
  <label>
    <font-awesome-icon :icon="['fas', 'upload']" />
    <input
      type="file"
      @change="
        uploadFile($event as InputEvent, uploadRecord.metadata!.documentId)
      "
    />
  </label>
</template>

<script lang="ts" setup>
  import { IUploadRecord } from '@/components/MassUpload/MassUpload.types';
  import { DocumentKind } from 'types';

  const props = defineProps<{
    documentType: DocumentKind;
    uploadRecord: IUploadRecord;
  }>();
  const emit = defineEmits<{
    (
      event: 'file-uploaded',
      documentId: string,
      file: File,
      type: DocumentKind,
    ): void;
  }>();

  function uploadFile(event: InputEvent, documentId: string) {
    const target = event.target as HTMLInputElement;
    const updatedFile = target?.files?.[0];
    if (!updatedFile) return;
    emit('file-uploaded', documentId, updatedFile, props.documentType);
  }
</script>

<style lang="scss" scoped>
  input[type='file'] {
    display: none;
  }
  svg {
    cursor: pointer;
  }
</style>
